import { Fragment, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import DynamicContactCampusBusiness from './DynamicContactCampusBusiness';
import DynamicContactCampusNormal from './DynamicContactCampusNormal';

export enum SustainerType {
  OwnSustainer = 'OS',
  NaturalPerson = 'NP',
  NaturalPersonWithPassport = 'NPWP',
  LegalPerson = 'LP',
}

type ContactSectionProps = {
  prefix: string;
  optionalFields?: string[];
  fieldNames?: {
    // Others
    addressStreet: string;
    addressNumber: string;
    addressExtra: string;
    country: string;
    region: string;
    commune: string;
    phone: string;
    cellPhone: string;
    email: string;
    location: string;
    // Business
    businessAddressStreet: string;
    businessAddressNumber: string;
    businessAddressExtra: string;
    businessCountry: string;
    businessRegion: string;
    businessCommune: string;
    businessPhone: string;
    businessCellPhone: string;
    businessEmail: string;
    businessLocation: string;
  };
  disabled?: boolean;
  hasEmail?: boolean;
};

/**
 * Para usar este componente tu formulario debe estar envuelto en su FormProvider
 * para poder acceder a la información del formulario a través de useFormContext
 * Los nombres agregados en fieldNames se relacionan a los campos que utilizaste
 * al definir tu formulario.
 */
const DynamicContactCampus = ({
  prefix,
  disabled = false,
  hasEmail = false,
}: ContactSectionProps) => {
  const { watch } = useFormContext();

  const sustainer = watch('sustainerType');

  const fields = useMemo(() => {
    if (sustainer?.value === SustainerType.LegalPerson) {
      return (
        <Fragment>
          <DynamicContactCampusBusiness
            prefix={prefix}
            disabled={disabled}
            hasEmail={hasEmail}
          />
        </Fragment>
      );
    }
    return (
      <Fragment>
        <DynamicContactCampusNormal
          prefix={prefix}
          disabled={disabled}
          hasEmail={hasEmail}
        />
      </Fragment>
    );
  }, [sustainer, hasEmail, disabled, prefix]);

  return <>{fields}</>;
};

export default DynamicContactCampus;
